import { Button, Text } from "monday-ui-react-core";
import MainService from "../services/MainService";

const FormBilling: React.FC = () => {
    function handleBilling() {
        MainService.showPlan();
    }

    return (<div className="w-4/5 mx-auto">
        <Text type={Text.types.TEXT2} color={Text.colors.PRIMARY}>
            You are currently on a free trial.
        </Text>
        <div>
            <Button onClick={handleBilling}>Manage Billing</Button>
        </div>
    </div>)
}


export default FormBilling;